import { render, staticRenderFns } from "./ItemDL_Details.vue?vue&type=template&id=2886f76a"
import script from "./ItemDL_Details.vue?vue&type=script&lang=js"
export * from "./ItemDL_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports